//src/services/dashboard.ts
import { api } from "@/lib/apiClient";
import type { DashboardOverview } from "@/types/dashboard";

export async function getDashboardOverview(inventoryId?: string) {
  return api.get<DashboardOverview>("/dashboard/overview", {
    params: {
      inventory_id: inventoryId || undefined,
    },
  });
}
